import { cloneDeep } from 'lodash-es';
import { apiPayableSiteExpenseGetPage } from '@/api/finance/receivables';
import { apiOptionForSelect, apiProviderChannel, apiProviderPage } from '@/api/finance/basicData';
import { apiCommonSite } from '@/api/logisticsOrders';
import { scanUserList } from '@/api/lanshou';
import { feePage } from '@/api/finance/partition';
import { collectDriverQueryCourierNew } from '@/api/logisticsOrders';
import store from '@/store';

/**
 * 获取列表数据
 * @param {{}} query 搜索字段
 * @returns {Promise<any[]>} 返回结果
   */
export const asyncGetList = (query) => {
  const queryForm = cloneDeep(query);

  queryForm.params.ids = [];

  return apiPayableSiteExpenseGetPage(queryForm).then(res => {
    return res;
  }).catch(err => {
    console.error(err);
  });
};

/**
 * 获取主体、网点、操作人、费用类型的下拉数据
 * @returns {Promise<any[]>} 返回结果
 */
export const initGetData = (() => {
  const providerList = 'providerList'; // 应付主体选项
  const outletsList = 'outletsList'; // 网点
  const providerChannelList = 'providerChannelList'; // 服务商
  const providerData = 'providerData'; // 运输主体
  // const operatorList = 'operatorList'; // 操作人

  // 从缓存中提前数据
  const getStorageData = (key) => {
    if (store.state.feesPayable[key] && store.state.feesPayable[key].length > 0) {
      return store.state.feesPayable[key];
    }
    return undefined;
  };

  /**
   * 获取主体数据
   * @returns
   */
  const providerParam = {
    pageSize: 9999999,
    pageNumber: 1,
    params: {
      state: 1
    }
  };
  const getProviderPage = () => {
    const arr = getStorageData(providerList);
    if (arr) {
      return Promise.resolve(arr);
    }

    return apiProviderPage(providerParam, false).then(res => {
      if (res.code === 200) {
        const { records } = res.data;
        // console.log(records, '主体');

        store.commit('feesPayable/SET_PROVIDER_LIST', records);
        return records;
      }
      throw new Error('获取主体数据失败');
    }).catch(err => {
      console.error(err);
      return [];
    });
  };
  // 运输主体
  const getProviderData = () => {
    const arr = getStorageData(providerData);
    if (arr) {
      return Promise.resolve(arr);
    }

    return apiOptionForSelect({ status: 2 }, false).then(res => {
      if (res.code === 200) {
        const data = res.data;

        store.commit('feesPayable/SET_PROVIDER_DATA', data);
        return data;
      }
      throw new Error('获取运输主体数据失败');
    }).catch(err => {
      console.error(err);
      return [];
    });
  };

  /**
   * 获取网点数据
   * @returns
   */
  const siteParams = {
    pageNumber: 1,
    pageSize: 9999999,
    params: {
      siteStatus: undefined,
      name: ''
    }
  };
  const getSitePageList = () => {
    const arr = getStorageData(outletsList);
    if (arr) {
      return Promise.resolve(arr);
    }
    return apiCommonSite(siteParams, false).then(res => {
      if (res.code === 200) {
        const { records } = res.data;
        // console.log(records, '网点');

        const list = records.map((item) => {
          return {
            id: item.id,
            name: item.name
          };
        });

        store.commit('feesPayable/SET_OUTLETS_LIST', list);
        return records;
      }
      throw new Error('获取网点数据失败');
    }).catch(err => {
      console.error(err);
      return [];
    });
  };

  /**
   * 获取服务商下拉数据
   * @params id 主体id
   */
  const providerChannelParam = {
    pageNumber: 1,
    pageSize: 9999999,
    params: {
      providerChannelCode: '',
      providerChannelName: ''
    }
  };
  const getProviderChannel = () => {
    const arr = getStorageData(providerChannelList);
    if (arr) {
      return Promise.resolve(arr);
    }

    return apiProviderChannel(providerChannelParam, false).then(res => {
      if (res.code === 200) {
        const { records } = res.data;
        // console.log(records, '服务商');

        store.commit('feesPayable/SET_PROVIDER_CHANNEL_LIST', records);
        return records;
      }
      throw new Error('获取服务商数据失败');
    }).catch(err => {
      console.error(err);
      return [];
    });
  };

  /**
   * 获取操作人
   */
  const operatorParams = { // user
    accountState: 1
  };
  const newOperatorParams = { // pm_user
    pageSize: 9999999,
    pageNumber: 1,
    params: {
      deliveryManName: ''
    }
  };
  const getOperatorList = (type) => {
    // type: 3 ->AJD操作人数据来源-供应商员工数据pm_user
    // 其他账单类型为系统用户数据user
    const { api, params } = type === 3
      ? { api: collectDriverQueryCourierNew, params: newOperatorParams }
      : { api: scanUserList, params: operatorParams };

    return api(params, false).then((response) => {
      const { code, data } = response;
      if (code === 200) {
        // const records = type === 3 ? response.data : response.data.records;
        const formatOperator = (item) => {
          if (type === 3) {
            const { deliveryManName, supplierId } = item;
            return Object.freeze({
              source: 2,
              dispatcherName: deliveryManName,
              dispatcherId: supplierId,
              value: supplierId,
              label: deliveryManName
            });
          } else {
            const { realName, id, organizationName, username } = item;
            return Object.freeze({
              value: id,
              label: `${realName}(${username})`,
              organizationName // 部门
            });
          }
        };

        const list = (data || []).map(formatOperator);
        try {
          type === 3
            ? store.commit('feesPayable/SET_PM_OPERATOR_LIST', list)
            : store.commit('feesPayable/SET_OPERATOR_LIST', list);
        } catch (e) {
          console.warn('store.commit failed:', e);
        }
        return data;
      }
      throw new Error(`获取操作人数据失败，type=${type}`);
    }).catch(err => {
      console.error(err);
      return [];
    });
  };

  /**
   * 获取费用类型
   * @param {*} type 业务类型 1 安俊 2 第三方 3 AJD 4 DSP 6 邮局派送
   * @returns
   */
  const feeParams = {
    orderDirection: 'DESC',
    pageNumber: 1,
    pageSize: 10000,
    params: {
      state: 1,
      attribute: 2, // 1 应收，2 应付
      accountType: 1, // 应付科目
      businessType: ''
    }
  };
  const getExpenseType = (type) => {
    feeParams.params.businessType = type;

    return feePage(feeParams, false).then(res => {
      if (res.code === 200) {
        const { records } = res.data;
        // console.log(records, '费用类型');

        store.commit('feesPayable/SET_FEE_TYPE_OPTION', records);
        return records;
      }
      throw new Error('获取费用类型数据失败');
    }).catch(err => {
      console.error(err);
      return [];
    });
  };

  // 初始化数据
  return (obj) => {
    const arr = [
      getProviderPage(),
      getProviderData(),
      getSitePageList(),
      getProviderChannel(),
      getOperatorList(obj.payableType),
      getExpenseType(obj.payableType)
    ];
    return Promise.allSettled(arr).then(res => {
      console.log(res, 'initGetData-缓存数据');
      const list = [];
      res.forEach((item) => {
        if (item.status === 'fulfilled') {
          list.push(item.value);
        } else {
          list.push([]);
        }
      });
      return list;
    });
  };
})();
